import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Form, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function Account() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userx = useSelector(state => state.user);
  const [user, setUser] = useState({});
  const [tfaLoading, setTFALoading] = useState(false);
  const [passLoading, setPassLoading] = useState(false);
  const [password, setPassword] = useState({
    oldpassword: "",
    password: "",
    repassword: ""
  })
  const [validation, setValidation] = useState({
    oldpassword: null,
    password: null,
    repassword: null
  })
  const changePassowrd = async () => {
    var initValidation = {
      oldpassword: null,
      password: null,
      repassword: null
    }
    var errored = false;

    if (password.oldpassword === "") {
      initValidation.oldpassword = "Old Password field is required"
      errored = true
    }
    if (password.password === "") {
      initValidation.password = "new Password field is required"
      errored = true
    }
    if (password.repassword === "") {
      initValidation.repassword = "repeat Password field is required"
      errored = true
    }

    if (password.repassword != password.password) {
      initValidation.password = "repeat Password and new password don't match"
      initValidation.repassword = "repeat Password and new password don't match"
      errored = true
    }

    setValidation(initValidation)
    if (errored) return;
    setValidation(initValidation);

    setPassLoading(true);

    const response = await axios.post(window.__CFG.API + "manager/UpdatePassword", password, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })

    setPassLoading(false);

    if (response.data.Error == null) {
      toast.success("Saved Sucessufully", {
        duration: 4000
      });
      setPassword({
        oldpassword: "",
        password: "",
        repassword: ""
      })
    } else {
      toast.error(response.data.Error, {
        duration: 4000
      });
    }
  }
  useEffect(() => {
    var usery = Object.assign({}, userx)
    if (userx.Logged) {
      setUser(usery.User)
    }
  }, [user])

  const DisableTFA = async () => {
    setTFALoading(true);

    const response = await axios.post(window.__CFG.API + "manager/Toggle2FA", {}, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })

    if(response.data.Error == null) {
      const userResponse = await axios.get(window.__CFG.API + "manager/GetUser", {
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("raff-token")
        }
      })

      setTFALoading(false);

      if (userResponse.data.Error == null) {
        dispatch({
          type: "SET_USER",
          data: {
            logged: true,
            user: userResponse.data.User,
          }
        })
      }
    }
  }

  return (
    <Container>
      <Row>
        <Col>
          <h4 className="text-start fw-bold mt-5">Current user</h4>
          <div className='mt-3' style={{ lineHeight: "1" }} >
            <p className='text-start'> <span style={{ color: "#061b2b", fontWeight: 500, paddingRight: 10 }}>Username:</span>{user?.Username}</p>
            <p className='text-start'><span style={{ color: "#061b2b", fontWeight: 500, paddingRight: 10 }}>Email:</span>{user?.Email}</p>
          </div>

          <div
            style={{
              borderBottom: "1px dashed black",
              marginTop: "30px",
              width: "100%",
            }}
          ></div>

          <h4 className="text-start fw-bold mt-4">Manage two-factor authentication</h4>
          <div className='mt-3' style={{ lineHeight: "0.5" }} >

            {
              userx.User.TFA === 1 ? (
                <p className='text-start'>Google Authenticator enabled: <b>Yes</b></p>
              ) : (
                <p className='text-start'>Google Authenticator enabled: No</p>
              )
            }

          </div>

          <Col lg={2} md={4} sm={5} className=" pt-2">
            {
              userx.User.TFA === 1 ? (
                <Button onClick={DisableTFA} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  {
                    tfaLoading ? (
                      <><Spinner size="sm"></Spinner></>
                    ) : (
                      <>Disable</>   
                    )
                  }
                </Button>
              ) : (
                <Button onClick={() => navigate("/affiliate/settings/tfa")} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  Enable
                </Button>
              )
            }
          </Col>


          <div
            style={{
              borderBottom: "1px dashed black",
              marginTop: "30px",
              width: "100%",
            }}
          ></div>

          <h4 className="text-start fw-bold mt-4">Change password</h4>

          <Row className="justify-content-between mt-4 me-auto w-75">

            <Col lg={4} md={4} sm={5}>
              <div className='form-aff-list-in'>
                <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                  <label>Old password</label>
                </div>
                <div className="dashboard-selec">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="password" value={password.oldpassword} onChange={(e) => { setPassword({ ...password, oldpassword: e.target.value }) }} />
                  {
                    validation.oldpassword !== null ? (
                      <div class="invalid-feedback loginForm">
                        {validation.oldpassword}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between mt-1 me-auto w-75">

            <Col lg={4} md={4} sm={5}>
              <div className='form-aff-list-in'>
                <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                  <label>new  password</label>
                </div>
                <div className="dashboard-sele passw-aff">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="password" value={password.password} onChange={(e) => { setPassword({ ...password, password: e.target.value }) }} />
                  {
                    validation.password !== null ? (
                      <div class="invalid-feedback loginForm">
                        {validation.password}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between mt-1 me-auto w-75">

            <Col lg={4} md={4} sm={5}>
              <div className='form-aff-list-in'>
                <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                  <label>repeat new password</label>
                </div>
                <div className="dashboard-s">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="password" value={password.repassword} onChange={(e) => { setPassword({ ...password, repassword: e.target.value }) }} />
                  {
                    validation.repassword !== null ? (
                      <div class="invalid-feedback loginForm">
                        {validation.repassword}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </div>
              </div>
            </Col>
          </Row>

          <div
            style={{
              borderBottom: "1px dashed black",
              marginTop: "30px",
              width: "100%",
            }}
          ></div>
          <Col lg={2} md={4} sm={5} className=" pt-2 mb-5">
            <Button onClick={changePassowrd} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
              {
                passLoading ? (
                  <Spinner size="sm" />
                ) : (
                  <>Change password</>
                )
              }
            </Button>
          </Col>





        </Col>
      </Row>
    </Container>
  )
}

export default Account